import { doGet } from './common'
import { getCompletedBreaks } from 'services/user'
import sessionStorageWrapper from 'util/SessionStorageWrapper'
import localStorageWrapper from 'util/LocalStorageWrapper'

export const getBreakStatus = breakId => {
  return doGet(`/break/${breakId}/status`)
  // if (localStorageWrapper.getItem(`break-${breakId}`)) {
  //     return JSON.parse(localStorageWrapper.getItem(`break-${breakId}`));
  // } else {
  //     return {}
  // }
}

/*
    returns a promise with payload
    {
        success: Boolean
        detail: Object
    }

*/
export const getFeaturedBreaks = ({ limit, sponsoredOnly = false }) => {
  // const params = {
  //     // zip: "00000",
  //     limit: (limit || 10)
  // }

  return doGet(`/break/featured?limit=${limit}&sponsoredOnly=${sponsoredOnly}`)
}

export const getPersonalityData = breakId => {
  const stored_id = sessionStorageWrapper.getItem(`${breakId}_pq_result_id`)
  if (stored_id) {
    return Promise.resolve({ detail: { resultId: stored_id } })
  } else {
    return doGet(`/break/${breakId}/personalityData`)
  }
}
export const getPointsForBreak = breakId => {
  return doGet(`/break/${breakId}/totalPoints`)
}

export const scrollToTopOfCurrentStep = stepId => {
  let obj = document.querySelector(`.step-topper-${stepId}`)
  if (obj) {
    obj && obj.scrollIntoView({ behavior: 'smooth', block: 'start' })
    obj &&
      window.parent.postMessage(
        { type: 'SCROLL_TO', value: obj.getBoundingClientRect().top },
        '*',
      )
  } else {
    console.log('no element found')
  }
}

export const scrollToTopOfEditorialStep = (behavior = 'smooth') => {
  let obj = document.querySelector(`main.editorial.container`)
  if (obj) {
    window.scrollTo({
      top: obj.offsetTop - 98, //approx. header height.
      behavior: behavior,
    })
  }
}

export const scrollToTopOfLandingStep = () => {
  let obj = document.querySelector('.sponsored-flow-wrapper')
  obj && obj.scrollIntoView({ behavior: 'smooth', block: 'start' })
  obj &&
    window.parent.postMessage(
      { type: 'SCROLL_TO', value: obj.getBoundingClientRect().top },
      '*',
    )
}

export const retrieveCompletedBreaksFromLocalOrAPI = breaks => {
  const retrieveCompletedBreaksFromLocal = breaks => {
    if (!window) return false
    const localObj = JSON.parse(
      localStorageWrapper.getItem('db_completed_brks'),
    )
    const localCompletedBrks = {}
    const leftoverBreaks = []
    if (localObj) {
      breaks.forEach(brk => {
        if (localObj[brk.id]) {
          localCompletedBrks[brk.id] = true
        } else {
          leftoverBreaks.push(brk)
        }
      })
      if (leftoverBreaks.length) {
        return retrieveCompletedBreaksFromAPI(
          localCompletedBrks,
          leftoverBreaks,
        )
      } else {
        // updateCompletedBreaks(localCompletedBrks)
        return localCompletedBrks
      }
    } else {
      return retrieveCompletedBreaksFromAPI(localCompletedBrks, breaks)
    }
  }

  const retrieveCompletedBreaksFromAPI = async (localCompletedBrks, breaks) => {
    let totalCompletedBrks = localCompletedBrks
    const breakIds = { breakIds: [...breaks].map(brk => brk.id) }
    try {
      const completedBrks = await getCompletedBreaks(breakIds)
      Object.keys(completedBrks.detail).forEach(key => {
        if (completedBrks.detail[key] === true) {
          totalCompletedBrks[key] = true
        }
      })
      // console.log('new api brks: ',completedBrks.detail)
      // console.log('total completed brks: ',totalCompletedBrks)
      // updateCompletedBreaks(totalCompletedBrks)
      saveCompletedBreaksToLocal(totalCompletedBrks)
      return totalCompletedBrks
    } catch (e) {
      console.log(e)
    }
  }

  const saveCompletedBreaksToLocal = breaks => {
    if (!window) return false
    const localObj = JSON.parse(
      localStorageWrapper.getItem('db_completed_brks'),
    )
    if (localObj) {
      Object.keys(breaks).forEach(id => {
        localObj[id] = true
      })
      localStorageWrapper.setItem('db_completed_brks', JSON.stringify(localObj))
    } else {
      localStorageWrapper.setItem('db_completed_brks', JSON.stringify(breaks))
    }
  }

  return retrieveCompletedBreaksFromLocal(breaks)
}

export const checkBreakTargetingForUser = breakId => {
  return doGet(`/break/${breakId}/isTargeted`)
}
